import React from 'react'
import { Flex, Box, Image, Text, Heading } from 'rebass/styled-components'

import onesrc from '../../images/icons/1.svg'
import twosrc from '../../images/icons/2.svg'
import threesrc from '../../images/icons/3.svg'
import foursrc from '../../images/icons/4.svg'
import fivesrc from '../../images/icons/5.svg'

const AdvantagesIconsBlock = () => {
  return (
    <Box backgroundColor="brown.300" px={[2, 3]} py={[3, 4]} mx={[-3]}>
      <Heading
        color="white"
        textAlign="center"
        mb={[2, 3]}
      >
        Мы производим любую мебель и столярные изделия по индивидуальным проектам
         </Heading>

      <Flex flexWrap="wrap">
        <Box width={[1, 1 / 2, 1 / 3, 1 / 5]} textAlign="center" mb={[3, 3, 3, 0]}>
          <Image src={onesrc} width={150} />
          <Text color="white">Собственное производство</Text>
        </Box>
        <Box width={[1, 1 / 2, 1 / 3, 1 / 5]} textAlign="center" mb={[3, 3, 3, 0]}>
          <Image src={twosrc} width={150} />
          <Text color="white">по вашему дизайну</Text>
        </Box>
        <Box width={[1, 1 / 2, 1 / 3, 1 / 5]} textAlign="center" mb={[3, 3, 3, 0]}>
          <Image src={threesrc} width={150} />
          <Text color="white">из любых материалов</Text>
        </Box>
        <Box width={[1, 1 / 2, 1 / 3, 1 / 5]} textAlign="center" mb={[3, 3, 3, 0]}>
          <Image src={foursrc} width={150} />
          <Text color="white">работа с регионами</Text>
        </Box>
        <Box width={[1, 1 / 2, 1 / 3, 1 / 5]} textAlign="center" mb={[3, 3, 3, 0]}>
          <Image src={fivesrc} width={150} />
          <Text color="white">соблюдение сроков</Text>
        </Box>
      </Flex>
    </Box>
  )
}

export default AdvantagesIconsBlock
